import Model from "../_model";

export default class ProformaInvoiceProductModel extends Model {
	constructor(provider) {
		super(provider, "proforma_invoices/{proformaInvoiceId}/products");
	}

	_getUrl(pid, id) {
		const base = this.apiMethod.replace("{proformaInvoiceId}", pid);
		return id ? `${base}/${id}` : base;
	}

	_buildBody(i) {
		const name = i && i.name && typeof i.name === "object" ? i.name : { _default: (i && i.name) || "" };

		return {
			productId: i.productId,
			variantId: i.variantId,
			name,
			unitCode: i.unitCode,
			quantity: i.quantity,
			amount: i.amount,
			lines: (i.lines || []).map((l) =>
				l.manual
					? {
							manual: true,
							quantity: l.quantity,
							measurementId: l.measurementId,
							pieces: l.pieces,
							length: l.length,
							width: l.width,
							height: l.height,
							value: l.value,
					  }
					: {
							stockId: l.stockId,
							batchId: l.batchId,
							measurementId: l.measurementId,
							batchMeasurementId: l.batchMeasurementId,
							pieces: l.pieces,
							quantity: l.quantity,
					  }
			),
		};
	}

	createGroup(pid, list, { onSuccess, onFail }) {
		const bodies = list.map((x) => this._buildBody(x));
		return super.create(bodies, { url: this._getUrl(pid), onSuccess, onFail });
	}

	update(pid, id, item, opts = {}) {
		const body = this._buildBody(item);
		const { onSuccess, onFail } = opts;
		return super.update(body, { url: this._getUrl(pid, id), onSuccess, onFail });
	}

	remove(pid, id, opts = {}) {
		const { onSuccess, onFail } = opts;
		return super.delete({
			url: this._getUrl(pid, id),
			onSuccess,
			onFail,
		});
	}

	get(pid, id, opts = {}) {
		const { onSuccess, onFail } = opts;
		return super.find({ url: this._getUrl(pid, id), onSuccess, onFail });
	}

	list(pid, opts = {}) {
		const { onSuccess, onFail } = opts;
		return super.filter({ url: this._getUrl(pid), onSuccess, onFail });
	}
}
